<template>
  <el-drawer title="" :visible.sync="isVisibleDrawerOrder" size="94%" :append-to-body="false" :modal-append-to-body="false" :show-close="false" :modal="false">
    <template #title>
      <div style="display: flex; align-items: center;">
        <el-button type="text" icon="el-icon-close" @click="onClickCloseDrawerOrder" style="font-size: 32px; font-weight:500" />
      </div>
    </template>
    <template>
      <!-- 主區域底層模板 -->
      <section class="drawer-layout Jost">
        <!-- 左邊 -->
        <section class="drawer-layout__left">
          <div class="drawer-layout__left-scroll">
            <div style="display: flex; flex-direction: column; justify-content: space-between;height: 100%;">
              <div>
                <FinalOrderListPartial
                  :title="editorMode === 'addon' ? '加購商品編輯' : '價格編輯與折扣'"
                  :bookings="detailedBookingList"
                  :calculateOrder="calculateOrder"
                  :summary="summaryBooking"
                  :subtotal="subTotal"
                  :activeNames="[]"
                />
                <CalculatedOrderListPartial
                  :price-adjustments="currentAdjustmentPrices"
                  :addon-items="currentAddonItems"
                  :subtotal="subTotal"
                  :stay-nights="stayNights"
                  :editor-mode="editorMode"
                  @removePriceItem="handleRemovePriceItem"
                />
              </div>
              <el-button type="primary" round class="action-btn" :disabled="isSameAdjustments" @click="onClickModifyAdjustmentPrice">確定修改</el-button>
            </div>
          </div>
        </section>

        <!-- 右邊 -->
        <section class="drawer-layout__right">
          <div class="drawer-layout__right-scroll">
            <div style="width: 100%;display: flex; flex-direction: column; justify-content: space-between;height: 100%;">
              <div>
                <template v-if="editorMode === 'price'">
                  <CalculatorOrderPricePane
                    ref="pricePane"
                    :tabs="tabs"
                    :active-name="activeName"
                    :current-pay-total="currentPayTotal"
                    :textarea="textarea"
                    @tab-click="handleTabClick"
                    @update:activeName="activeName = $event"
                    @update:textarea="textarea = $event"
                    @update:adjustPriceItem="updateAdjustPriceItem"
                  />
                </template>
                <template v-else>
                  <CalculatorOrderAddonPane
                    :addon-loading="addonLoading"
                    :addon-goods="addonGoods"
                    :addon-pagination="addonPagination"
                    :selected-pet-id="selectedPetId"
                    :current-pet-options="currentPetOptions"
                    :addon-qty="addonQty"
                    :get-addon-price-value="getAddonPriceValue"
                    @addon-page-change="onAddonPageChange"
                    @update:selectedPetId="selectedPetId = $event"
                    @update:addonQty="addonQty = $event"
                    @update:selectedAddonRow="selectedAddonRow = $event"
                  />
                </template>
              </div>
              <el-button type="primary" round class="action-btn" :disabled="!canSubmitCurrentInput" @click="onClickUpdatePriceItem">
                {{ editorMode === 'addon' ? '加入加購' : '輸入變價' }}
              </el-button>
            </div>
          </div>
        </section>
      </section>
    </template>
  </el-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import { getHotelGoodsOptions } from '@/src/apis/hotelGoods'
import { getHotelGoodsPriceDisplay, getHotelGoodsPriceNumber } from '@/src/utils/hotel-goods-price'

import CalculatorOrderPricePane from './CalculatorOrderPricePane.vue'
import CalculatorOrderAddonPane from './CalculatorOrderAddonPane.vue'
import CalculatedOrderListPartial from './CalculatedOrderListPartial.vue'
import FinalOrderListPartial from './FinalOrderListPartial.vue'

export default {
  name: 'CalculatorOrderPartial',
  components: {
    CalculatorOrderPricePane,
    CalculatorOrderAddonPane,
    CalculatedOrderListPartial,
    FinalOrderListPartial,
  },
  props: {
    // 控制建立訂單流程抽屜顯示與否
    value: {
      type: Boolean,
      default: true,
    },
    editorMode: {
      type: String,
      default: 'price',
      validator: (val) => ['addon', 'price'].includes(val),
    },
  },
  data() {
    return {
      activeName: 'add',
      currentAdjustmentPrices: [],
      currentAddonItems: [],
      tempAdjustPriceItem: {},
      textarea: '',
      tabs: [{ name: '加價', value: 'add' }, { name: '減價', value: 'minus' }, { name: '折扣', value: 'discount' }],
      addonGoods: [],
      addonPagination: {
        page: 1,
        perPage: 15,
        total: 0,
      },
      addonLoading: false,
      selectedPetId: null,
      selectedAddonRow: null,
      addonQty: 1,
    }
  },
  // 父層把 value（或 isOpenCalculator）設為 true → 子層就會自動更新暫存
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.currentAdjustmentPrices = JSON.parse(JSON.stringify(this.priceAdjustments || []))
          this.currentAddonItems = JSON.parse(JSON.stringify(this.addonItems || []))
          if (!this.selectedPetId && Array.isArray(this.selectedPets) && this.selectedPets.length > 0) {
            this.selectedPetId = this.selectedPets[0].id
          }
          this.fetchAddonGoods()
          this.$emit('update-total', this.currentPayTotal)
        }
      },
      immediate: true,
    },
    selectedPetId() {
      this.addonPagination.page = 1
      this.selectedAddonRow = null
      this.fetchAddonGoods()
    },
    currentPayTotal: {
      handler(newVal) {
        this.$emit('update-total', newVal)
      },
      immediate: true,
    },
  },
  computed: {
    isVisibleDrawerOrder: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    isSameAdjustments() {
      return JSON.stringify(this.currentAdjustmentPrices) === JSON.stringify(this.priceAdjustments) && JSON.stringify(this.currentAddonItems) === JSON.stringify(this.addonItems)
    },
    currentPayTotal() {
      const normalizedPriceItems = this.normalizePriceItems(this.currentAdjustmentPrices || [])
      const normalizedAddonItems = this.normalizeAddonItems(this.currentAddonItems || [])
      const allItems = [...normalizedPriceItems, ...normalizedAddonItems]
      const localAdjustment = allItems.reduce((acc, cur) => acc + this.getSignedDelta(cur), 0)
      return (this.subTotal || 0) + localAdjustment
    },
    canSubmitCurrentInput() {
      return this.editorMode === 'addon' ? !!this.selectedAddonRow : this.tempAdjustPriceItem.amount !== '0'
    },
    addonTableData() {
      const list = Array.isArray(this.addonGoods) ? this.addonGoods : []
      return list.map((item, index) => {
        const base = item?.goods && typeof item.goods === 'object' ? item.goods : item
        const id = base?.id || base?.value || item?.id || item?.value || `addon-${index}`
        const displayName = this.getAddonDisplayName(base)
        const displayPrice = this.resolveAddonPrice(item)
        return {
          id,
          displayName,
          displayPrice,
          raw: item,
        }
      })
    },
    currentPetOptions() {
      return Array.isArray(this.selectedPets) ? this.selectedPets : []
    },
    ...mapGetters('hotel/order', ['detailedBookingList', 'calculateOrder', 'summaryBooking', 'subTotal', 'priceAdjustments', 'addonItems', 'selectedPets']),
    ...mapGetters('hotel/setting', ['currentProduct']),
    stayNights() {
      const n = Number(this.summaryBooking?.nights)
      return Number.isFinite(n) && n > 0 ? n : 1
    },
  },
  methods: {
    normalizePriceItems(items = []) {
      return items.map((item) => ({
        ...item,
        itemType: 'price',
        type: item.type,
        reason: item.reason || item.title || '-',
        amount: Math.abs(Number(item.amount) || 0),
        qty: Number(item.qty || item.quantity || 1),
      }))
    },
    normalizeAddonItems(items = []) {
      return items.map((item) => ({
        ...item,
        itemType: 'addon',
        type: 'add',
        reason: item.reason || item.title || '-',
        amount: this.getAddonUnitAmount(item),
        qty: Number(item.qty || item.quantity || 1),
      }))
    },
    getAddonUnitAmount(item = {}) {
      if (item.adjustPrice != null) return Math.abs(Number(item.adjustPrice) || 0)
      if (item.amount != null) return Math.abs(Number(item.amount) || 0)
      if (item.addonPrice != null) return Math.abs(Number(item.addonPrice) || 0)
      if (item.unitPrice != null) return Math.abs(Number(item.unitPrice) || 0)
      const qty = Math.max(1, Number(item.qty || item.quantity || 1))
      if (item.lineTotal != null) return Math.abs((Number(item.lineTotal) || 0) / qty)
      return 0
    },
    getSignedDelta(item) {
      const amount = Math.abs(Number(item.amount) || 0)
      const qty = Math.max(1, Number(item.qty || item.quantity || 1))
      const nightFactor =
        item.itemType === 'addon' && item.billingType === 'per_night' ? this.stayNights : 1
      const isNegative = item.itemType === 'price' && ['minus', 'discount'].includes(item.type)
      return (isNegative ? -1 : 1) * amount * qty * nightFactor
    },
    getPetCategoryIds(pet = {}) {
      const ids = []
      if (pet.categoryId != null) ids.push(pet.categoryId)
      if (pet.category && typeof pet.category === 'object' && pet.category.id != null) ids.push(pet.category.id)
      if (Array.isArray(pet.categories)) {
        pet.categories.forEach((cat) => {
          if (cat == null) return
          if (typeof cat === 'object' && cat.id != null) ids.push(cat.id)
          if (typeof cat === 'number' || typeof cat === 'string') ids.push(cat)
        })
      }
      return [...new Set(ids.filter((v) => v !== null && v !== undefined && v !== ''))]
    },
    async fetchAddonGoods() {
      if (this.editorMode !== 'addon') return
      this.addonLoading = true
      try {
        const selectedPet = this.currentPetOptions.find((pet) => pet.id === this.selectedPetId)
        const categoryIds = this.getPetCategoryIds(selectedPet)
        const params = {
          page: this.addonPagination.page,
          perPage: this.addonPagination.perPage,
          productId: this.currentProduct.id,
        }
        // options API 規格為 categoryId（單值）
        if (categoryIds.length > 0) {
          params.categoryId = Number(categoryIds[0])
        }
        const response = await getHotelGoodsOptions(params)
        const rawItems = Array.isArray(response) ? response : response?.items || response?.data?.items || []
        const items = Array.isArray(rawItems) ? rawItems : Object.values(rawItems || {})
        const pagination = response?.pagination || {}
        this.addonGoods = items
        this.addonPagination.total = Number(pagination.total) || items.length
      } catch (error) {
        console.error(error)
        this.addonGoods = []
        this.addonPagination.total = 0
      } finally {
        this.addonLoading = false
      }
    },
    onAddonPageChange(page) {
      this.addonPagination.page = page
      this.fetchAddonGoods()
    },
    onCurrentAddonChange(row) {
      this.selectedAddonRow = row?.raw || row || null
    },
    getAddonPriceValue(goods, field) {
      return getHotelGoodsPriceDisplay(goods, field)
    },
    resolveAddonPrice(goods) {
      return getHotelGoodsPriceNumber(goods, 'price')
    },
    getAddonDisplayName(goods) {
      if (!goods) return '-'
      return goods.name || goods.title || goods.label || '-'
    },
    resolveAddonBillingType(goods) {
      if (!goods || typeof goods !== 'object') return null
      if (goods.billingType) return goods.billingType
      const base = goods.goods && typeof goods.goods === 'object' ? goods.goods : goods
      return base.billingType || null
    },
    addAddonItem() {
      if (!this.selectedAddonRow) return
      const qty = Math.max(1, Math.min(100, Number(this.addonQty) || 1))
      const amount = this.resolveAddonPrice(this.selectedAddonRow)
      const billingType = this.resolveAddonBillingType(this.selectedAddonRow)
      const selectedPet = this.currentPetOptions.find((pet) => pet.id === this.selectedPetId)
      const reasonPrefix = selectedPet?.name ? `${selectedPet.name}｜` : ''
      const addonTitle = this.getAddonDisplayName(this.selectedAddonRow)
      const addonId = this.selectedAddonRow.id || this.selectedAddonRow.value
      const targetIndex = this.currentAddonItems.findIndex((item) => item.petId === this.selectedPetId && item.addonId === addonId && item.itemType === 'addon')

      if (targetIndex >= 0) {
        const currentQty = Number(this.currentAddonItems[targetIndex].qty || 1)
        this.$set(this.currentAddonItems[targetIndex], 'qty', Math.min(100, currentQty + qty))
      } else {
        this.currentAddonItems.push({
          itemType: 'addon',
          type: 'add',
          title: addonTitle,
          reason: `${reasonPrefix}${addonTitle}`,
          amount,
          adjustPrice: amount,
          qty,
          petId: this.selectedPetId,
          addonId,
          ...(billingType ? { billingType } : {}),
        })
      }
      this.addonQty = 1
    },
    handleTabClick() {
      console.log(this.activeName)
    },
    updateAdjustPriceItem(adjustPriceItem) {
      this.tempAdjustPriceItem = adjustPriceItem
      console.log('temp', adjustPriceItem)
    },
    onClickUpdatePriceItem() {
      if (this.editorMode === 'addon') {
        this.addAddonItem()
        return
      }
      if (!this.textarea) this.textarea = '-'

      // 1. 直接使用已經從 emit 拿到且計算正確的 tempAdjustPriceItem
      // 使用深拷貝確保資料斷開引用
      const merged = {
        ...JSON.parse(JSON.stringify(this.tempAdjustPriceItem)),
        itemType: 'price',
        qty: 1,
        reason: this.textarea, // 補上備註
      }

      console.log(merged)

      if (this.$refs.pricePane && this.$refs.pricePane.clearInputByTab) {
        this.$refs.pricePane.clearInputByTab(this.activeName)
      }

      this.currentAdjustmentPrices.push(merged)

      this.textarea = ''
      this.tempAdjustPriceItem = { amount: '0' }
    },
    onClickModifyAdjustmentPrice() {
      this.$store.commit('hotel/order/SET_PRICEADJUSTMENT', JSON.parse(JSON.stringify(this.currentAdjustmentPrices)))
      this.$store.commit('hotel/order/SET_ADDONITEMS', JSON.parse(JSON.stringify(this.currentAddonItems)))
      // 關閉對話窗
      this.$emit('input', false)
    },
    resetData() {
      this.currentAdjustmentPrices = []
      this.currentAddonItems = []
      this.tempAdjustPriceItem = {}
      this.textarea = ''
      this.selectedAddonRow = null
      this.addonQty = 1
    },
    async onClickCloseDrawerOrder() {
      const isAddonMode = this.editorMode === 'addon'
      const message = isAddonMode ? '您尚未儲存加購商品，是否直接關閉加購商品編輯？' : '您尚未修改價格，是否直接關閉計算機？'
      const title = isAddonMode ? '離開加購商品編輯' : '離開價格編輯與折扣'
      try {
        await this.$confirm(message, title, {
          confirmButtonText: '確定關閉',
          cancelButtonText: '返回編輯',
        })
        // 使用者按下「確定」
        this.resetData()
        // 關閉對話窗
        this.$emit('input', false)
      } catch (err) {
        console.log(err)
      }
    },
    handleRemovePriceItem(index) {
      const merged = [...this.normalizePriceItems(this.currentAdjustmentPrices), ...this.normalizeAddonItems(this.currentAddonItems)]
      const target = merged[index]
      if (!target) return
      if (target.itemType === 'addon') {
        const addonIndex = this.currentAddonItems.findIndex((item) => item.petId === target.petId && item.addonId === target.addonId)
        if (addonIndex >= 0) this.currentAddonItems.splice(addonIndex, 1)
        return
      }
      const priceIndex = this.currentAdjustmentPrices.findIndex((item) => item.reason === target.reason && item.type === target.type && Number(item.amount) === Number(target.amount))
      if (priceIndex >= 0) this.currentAdjustmentPrices.splice(priceIndex, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer__header {
  position: fixed;
  top: 0px;
  left: 75px;
  padding: 0px;
}

::v-deep .el-drawer__close-btn {
  font-size: 2.5rem;
}

::v-deep .el-tabs .el-tabs__item {
  font-size: 1.3rem;
}

::v-deep .el-textarea__inner {
  border: solid 2px #e5e7eb;
  border-radius: 8px;
  font-size: 18px;
  background-color: #ffffff;

  &:focus {
    border: solid 1px #ea6a29;
  }
}

.drawer-layout {
  display: flex;
  height: calc(100vh - 60px); // adjust if drawer header changes
  width: 96%;
  position: relative;
  margin: 0 20px 0 50px;

  &__left {
    width: 50%;
    height: 100%;
    overflow: hidden;
    border-right: 2px solid #e6e6e6;
    display: flex;
    flex-direction: column;
    padding: 16px;
    padding-bottom: 0px;

    &-scroll {
      flex: 1;
      overflow-y: auto;
      display: flex;
      flex-direction: column;

      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #999;
        border-radius: 4px;
        border: 2px solid #f0f0f0;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #666;
      }
    }

    &-header {
      position: sticky;
      top: 8px;
      padding-top: 18px;
      z-index: 10;
      background-color: #f9f9fb;
      border-bottom: 1px solid #e6e6e6;
      font-size: 18px;
      font-weight: 700;
      line-height: 2.2;
    }

    &-content {
      margin: 20px 10px 0px 0px;
    }
  }

  &__right {
    width: 50%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &-scroll {
      flex: 1;
      overflow-y: auto;
      padding: 16px 16px 0;
      font-size: 16px;
      line-height: 1.8;

      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #999;
        border-radius: 4px;
        border: 2px solid #f0f0f0;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #666;
      }
    }
  }
}

.action-btn {
  width: 100%;
  height: 44px;
  margin-top: 24px;
}

.pet-radio-wrapper {
  min-height: 180px;
  max-height: 180px; // 約顯示 3 排（6 隻），超過才 scroll
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999;
    border-radius: 4px;
    border: 2px solid #f0f0f0;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #666;
  }
}

.pet-radio-group {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.pet-radio-item {
  margin-right: 0;
  margin-left: 0 !important; // 覆蓋 ElementUI el-radio--border 預設 margin-left
  width: 100%;
  min-height: 50px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: solid 2px #e5e7eb;
  border-radius: 8px;
  padding-top: 0px;

  ::v-deep .el-radio__label {
    font-size: 15px;
  }
}
</style>
